import {Link} from "react-router-dom";
import logo from "../../../images/Logo-login.png";
import logoMobile from "../../../images/LogoM.png";
// import login from "../../../images/login-bg.jpg";
// import login from "../../../images/cover-login.jpg";
// import login from "../../../images/cover-login-2.jpg";
import login from "../../../images/login-image.png";
const SideBg = () => {
  return (
    <>
      <div
        className="login-aside-left !flex lg:!w-1/3 max-[992px]:!bg-transparent max-[992px]:!bg-none bg-[#5ac2ff] relative "
        // style={{backgroundImage: "url(" + login + ")"}}
      >
        <img
          src={login}
          alt=""
          className="absolute top-[45%] left-[50%] -translate-x-[50%] -translate-y-[50%] max-[992px]:!hidden  -z-10 max-h-[47vh] "
        />
        {/* <div className="login-description"> */}
        <div className="w-full  flex-col justify-between items-center hidden max-[992px]:!flex ">
          <Link to={"/login"}>
            <img src={logoMobile} alt="logo" className=" w-[187px]" />
          </Link>
        </div>

        <div className="w-full min-h-[calc(100vh-100px)] flex-grow flex flex-col  justify-between items-center max-[992px]:!hidden ">
          <Link to={"/login"}>
            <img src={logo} alt="logo" className=" max-h-[12vh]" />
          </Link>

          <div className="flex flex-col justify-center items-center">
            <h2 className="text-white font-[Poppins] flex flex-col items-center justify-center font-bold text-[28px] 2xl:text-[30px] leading-[36px] text-center uppercase mb-3 ">
              {/* drop-shadow-[0px_0px_8px_rgba(1,25,46,1) */}
              <span>
                Help Clic, chez <span className="text-nowrap"> vous en </span>{" "}
              </span>
              <span className="text-[#FF6600] whitespace-nowrap ">
                {" "}
                un clic!
              </span>
            </h2>
            <ul className="social-icons align-bottom ">
              <li>
                <Link to={"https://www.facebook.com/helpclic"} target="_blank">
                  <i className="fa fa-facebook "></i>
                </Link>
              </li>
              <li>
                <Link
                  to={"https://www.instagram.com/help.clic/"}
                  target="_blank"
                >
                  <i className="fa fa-instagram"></i>
                </Link>
              </li>
              <li>
                <Link
                  to={"https://www.linkedin.com/company/help-clic/"}
                  target="_blank"
                >
                  <i className="fa fa-linkedin"></i>
                </Link>
              </li>
              <li>
                <Link to={"https://www.youtube.com/@Help-clic"} target="_blank">
                  <i className="fa fa-youtube-play" aria-hidden="true"></i>
                </Link>
              </li>
              <li>
                <Link to={"https://www.tiktok.com/@help.clic"} target="_blank">
                  <i className="fi fi-brands-tik-tok"></i>
                </Link>
              </li>
            </ul>
            <Link
              to="/politique-de-confidentialite"
              className="mt-3 text-sm font-medium text-white underline underline-offset-2 hover:text-white"
            >
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
export default SideBg;
